module.exports = __webpack_public_path__ + "static/media/lending-tools7.039dbf79.svg";